// extracted by mini-css-extract-plugin
export default {"userAvatar":"styles_userAvatar__ei12w","overlay":"styles_overlay__T42Eq"};